import styled from "styled-components";

export const LinkButton = styled.a`
  bottom: 40px;
  position: fixed;
  right: 40px;
`